import styles from './PageSection.module.css';

const PageSection = ({ children }: { children: React.ReactNode }) => {
    return (
        <section className={styles.pageSection}>
            {children}
        </section>
    );
}

export default PageSection;